import { lookupTableReducer } from 'Modules/core/redux';

import { infoActions } from './actions';


const actionLookup = {
    [`${infoActions.set}`]: (state, { lang, data }) => ({
        ...state,
        [lang]: data,
    }),
};

export const reducer = lookupTableReducer({}, actionLookup);
